import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'searchHighlighter'
})
export class SearchHighlighterPipe implements PipeTransform {
  transform(value: any, args: any): any {
    if (!args) {
      return value;
    }
    var re = new RegExp(args, 'gi');
    return value.replace(re, '<span class="searchHighliter">$&</span>');
  }
}
